// ResponsiveCategories.jsx → src/gestion-categories/
import React from "react";
import GestionCategories from "./GestionCategories";
import CategoriesMobile from "../mobile/produits/CategoriesMobile";
import useIsMobile from "../hooks/useIsMobile";

export default function ResponsiveCategories(props) {
  return useIsMobile() ? <CategoriesMobile {...props} /> : <GestionCategories {...props} />;
}
